import {
  RecordingFragment,
  RecordingQuery,
  RecordingQueryVariables,
  useRecordingQuery,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

export const useRecording = withStandardGetHook<
  RecordingQuery,
  RecordingFragment,
  'recording',
  RecordingQueryVariables
>(useRecordingQuery, 'recording');
